import { Link } from 'react-router-dom';

/**
 * "Back to Campaigns" link with an arrow that nudges left on hover.
 * Shared by the Campaign page header and the error / not-found states.
 */
export function BackToCampaignsLink() {
  return (
    <Link
      to="/account"
      className="group inline-flex items-center text-blue-600 hover:text-blue-800"
    >
      <svg
        aria-hidden="true"
        className="mr-2 w-5 h-5 transition-transform duration-200 group-hover:-translate-x-1"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 7l-5 5m0 0l5 5m-5-5h12" />
      </svg>
      Back to Campaigns
    </Link>
  );
}
